// extracted by mini-css-extract-plugin
export default {"tick":"ShowTick_tick__LSKOC"};